import React, { useEffect, useState } from 'react'
import Colors from 'utils/Colors'
import PolicyIcon from '@mui/icons-material/Policy'
import { Modal } from 'components'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import Button from '@mui/material/Button'
import ReviewsCompleteList from 'components/ManualAnalysisList/ReviewsCompleteList'
import { get } from 'services/api'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import styles from '../styles'

const ApplicationReviewsButton = ({ application, useTitle = false }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [reviews, setReviews] = useState({})
  const [loading, setLoading] = useState(false)
  const token = useSelector((state) => state.auth.access_token)

  useEffect(() => {
    if (!_.isEmpty(reviews)) {
      setModalOpen(true)
    }
  }, [reviews])

  const handleCloseLogModal = () => {
    setModalOpen(false)
  }

  const classes = styles()

  const handleOpenLog = async () => {
    setLoading(true)

    const res = await get({
      url: `/applications/${application.uuid}/reviews`,
      token,
    })

    if (res) {
      setReviews(res)
    }

    setLoading(false)
  }

  const renderIconButton = () => (
    <span>
      {loading ? (
        <CircularProgress size={18} color="primary" />
      ) : (
        <IconButton onClick={() => handleOpenLog()} size="large">
          <PolicyIcon
            style={{
              color: Colors.primaryColor,
              fontSize: 20,
            }}
          />
        </IconButton>
      )}
    </span>
  )

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      onClick={() => handleOpenLog()}
      startIcon={
        loading ? (
          <CircularProgress size={18} color="primary" />
        ) : (
          <PolicyIcon
            style={{
              color: Colors.primaryColor,
              fontSize: 20,
            }}
          />
        )
      }
    >
      Revisões
    </Button>
  )

  return (
    <React.Fragment>
      <Tooltip
        arrow
        placement="top"
        title={
          <b className={classes.tooltipText}>
            Abrir panorama
            <br />
            de revisões da aplicação
          </b>
        }
      >
        {useTitle ? renderLabeledButton() : renderIconButton()}
      </Tooltip>
      <Modal
        open={modalOpen}
        onClose={() => handleCloseLogModal()}
        title="Panorama de Revisões Manuais"
      >
        <ReviewsCompleteList
          bgcReviews={reviews?.bgc_reviews}
          rfcReviews={reviews?.rfc_reviews}
        />
      </Modal>
    </React.Fragment>
  )
}

export default ApplicationReviewsButton
